<template>
    <div class="barcode-scanner__search mt-3 d-flex align-items-center" style="width: 100% !important;">
      <b-input-group class="barcode-scanner__search-input">
        <b-form-input
          :value="barcode"
          @input="handleInput($event)"
          :state="inputStatus"
          :placeholder="$t('Enter Barcode number')"
          >
        </b-form-input>
        <div class="validation-error" v-if="disabled && error">
            <div class="error_message">{{errorMessage}}</div>
        </div>
        <b-form-invalid-feedback id="input-live-feedback">
          {{$t('Wrong Barcode Number')}}
        </b-form-invalid-feedback>
        <b-form-valid-feedback id="input-live-feedback">
          {{$t('Correct Barcode Number')}}
        </b-form-valid-feedback>
      </b-input-group>
      <buttonComponent
        addClass="secondaryButton absolute bottom customColor"
        :disabled="disabled"
        :class="`btn_${status}`"
        @click.native="searchProductByBarcode({ barcode, maxProductCount })"
        :text="$t(texts.barcodeAdd)"
        :grid= "{columns: 6}"
        />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import buttonComponent from "@/components/renderers/button-component.vue"
export default {
  name: 'searchModule',
  components: { buttonComponent },
  data () {
    return {
      disabled: false,
      error: false,
      errorMessage: 'Bitte trage exakt 13 Stellen für einen gültigen Barcode ein.'
    }
  },
  props: {
    apiUrl: {
      type: String
    },
    texts: {
      required: false,
      type: Object,
      default: () => {}
    },
    maxProductCount: Number
  },
  computed: {
    ...mapState({
      barcode: state => state.productCode,
      status: state => state.searchStatus
    }),
    inputStatus () {
      let state;
      switch(this.status) {
      case 'success':
        state = true
        break;
      case 'not_found':
        state = false
        break;
      case null:
        state = null
        break;
      default:
        break;
      }
      return state
    }
  },
  methods:
  {
    ...mapActions(["uploadFile", "getBarCode", "findProducts", "handleProductCode", "updateSearchStatus", "searchProductByBarcode", "checkBarCodeParticipating" ]),
    handleInput (ev) {
      this.updateSearchStatus(null);
      this.handleProductCode(ev)
    },
    resetSelectedProducts () {
      this.$store.commit('resetProducts');
      this.$store.commit('setProductCode', '');
      this.$store.commit('setSearchStatus', null);
    }
  },
  mounted () {
    this.code = this.barcode;
    this.$eventHub.$on("resetProducts-event", this.resetSelectedProducts);
  }
}
</script>

<style scoped lang="scss">
  .btn_disabled {
    font-size: 16px;
    font-weight: 500;
  }
 input[type=file] {
    position: absolute;
    left: -99999px;
  }
  .hide {
    display:none
  }
  .form-control {
    display: block;
    width: 100%;
    font-size: 14px !important;

    &::placeholder {
      color: #DAE0E7;
      font: italic normal 400 14px/25px 'Plus Jakarta Sans';
    }
  }
  label {
    margin-bottom: 0;
  }
  .was-validated .form-control:invalid, .form-control.is-invalid,
  .form-control:valid, .form-control.is-valid {
    background-image: none !important;
  }
  .barcode-scanner {
    &__search {
      width: 100%;
      flex-direction: column;
      justify-content: center;
      padding: 0 !important;
      &-input {
        input {
          height: 48px;
          font: normal normal 500 17px/20px 'Plus Jakarta Sans';
          letter-spacing: 0px;
          color: #200E32;
          z-index: 0 !important;
          background: #FFFFFF !important;
          border: 1px solid var(--input-border-color) !important;
          box-sizing: border-box !important;
          border-radius: 8px !important;
          margin-bottom: 10px;
          @media (max-width: 425px) {
            font-size: 10.5px;
          }
        }
      }
    }
    &__divider {
      width: 100%;
      margin-top: 50px;
      hr {
        border: 1px solid #939393;
      }
      .col-6 {
        font-size: 20px;
        line-height: 32px;
      }
    }
  }

@media (max-width: 768px) {
  .barcode-scanner__search {
    padding: 0;
  }
}

.error_message {
  display: inline-block;
}

.plus {
  @media (max-width: 450px) { display: none;}
}

.invalid-feedback, .validation-error, .valid-feedback {
  top: 48px !important;
}
</style>
